import PouchDB from 'pouchdb-browser';
import find from 'pouchdb-find';

PouchDB.plugin(find);
// Initialize and configure your PouchDB instance
const db = new PouchDB('meme-db', {
  adapter: 'idb', // Use IndexedDB or choose another adapter
});

db.createIndex({
  index: { fields: ['type'] }
}).then(() => {
  console.log('Index created successfully');
}).catch((error) => {
  console.error('Error creating index:', error);
});

export default db;

